import React from 'react';
import { connect } from 'react-redux';
import { getDarkMode } from 'selectors/theme';
import './Loader.css';
import loaderSvg from './loader.svg';
import loaderSvgDark from './loaderDark.svg';

// What the user sees while a route's code is being downloaded: the same spinner overlay the app already shows
// while a request is running (Loader), so a lazy route looks like any other loading page.
export const RouteFallbackView = ({ darkMode }) => (
  <div className="loader-container" data-test-id="route-fallback">
    <img src={darkMode ? loaderSvgDark : loaderSvg} alt="loader" />
  </div>
);

export default connect((state) => ({ darkMode: getDarkMode(state) }))(
  RouteFallbackView
);
